var React = require('react');

function StarEmpty (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#fff","strokeWidth":"2","d":"m10.696 10.253.522-.077.231-.474L15 2.416l3.551 7.286.232.474.522.077 7.965 1.172-5.772 5.697-.37.365.086.514 1.36 8.027-7.104-3.781-.47-.25-.47.25-7.104 3.781 1.36-8.027.087-.514-.37-.365-5.773-5.697z"}));
}

StarEmpty.defaultProps = {"width":"30","height":"28","fill":"none","viewBox":"0 0 30 28"};

module.exports = StarEmpty;

StarEmpty.default = StarEmpty;
